var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCopyLinkIcon = function SvgCopyLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5a1 1 0 01.993.883L2 6v7h7a1 1 0 01.993.883L10 14a1 1 0 01-.883.993L9 15H1a1 1 0 01-.993-.883L0 14V6a1 1 0 011-1zm12-5a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V2a2 2 0 012-2h8zm0 2H5v8h8V2z",
    fill: "currentColor"
  })));
};
export default SvgCopyLinkIcon;